import * as Roles from "@/constants/roles";

const RoleUtils = {
    getRoleName(role) {
        switch (role) {
            case Roles.SUPER_ADMIN:
                return "Super Administrator";
            case Roles.ADMIN:
                return "Administrator";
            case Roles.ACCOUNTANT:
                return "Accountant";
            case Roles.EMPLOYEE:
                return "Employee";
            case Roles.CORPORATION_OWNER:
                return "Corporation Owner";
            case Roles.COMMUNITY_MANAGER:
                return "Community Manager";
            case Roles.COMMUNITY_ACCOUNTANT:
                return "Community Accountant";
        }
        return null;
    }
};

export default RoleUtils;
